import { Phone, MapPin, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { siteInfo } from '../../data/mock';

export const FooterContact = ({ handleWhatsAppClick }) => (
<div>
              <h3 className="text-xl font-bold text-red-600 mb-6">Contact Rapide</h3>
              <ul className="space-y-4 text-gray-400">
                <li className="flex items-center space-x-3">
                  <MessageCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                  <div>
                    <p className="text-white font-semibold">WhatsApp</p>
                    <p data-testid="footer-whatsapp-number" className="text-sm">{siteInfo.phoneDisplay}</p>
                  </div>
                </li>
                <li className="flex items-center space-x-3">
                  <Phone className="w-5 h-5 text-red-500 flex-shrink-0" />
                  <div>
                    <p className="text-white font-semibold">Téléphone</p>
                    <p data-testid="footer-phone-number" className="text-sm">{siteInfo.phoneDisplay}</p>
                  </div>
                </li>
                <li className="flex items-center space-x-3">
                  <MapPin className="w-5 h-5 text-yellow-500 flex-shrink-0" />
                  <div>
                    <p className="text-white font-semibold">Adresse</p>
                    <p className="text-sm">{siteInfo.address}</p>
                  </div>
                </li>
              </ul>
              <Button 
                data-testid="footer-whatsapp-button"
                onClick={handleWhatsAppClick}
                className="w-full mt-6 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold"
              >
                <MessageCircle className="w-4 h-4 mr-2" />
                WhatsApp
              </Button>
            </div>
);
